import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardCard from '../leave-dashboard/components/DashboardCard';
import RowAvatar from '../leave-dashboard/components/RowAvatar';
import { initialsOf } from '../leave-dashboard/components/TodayOnLeaveCard';
import {
  ListRow, RowMain, RowName, RowSub, RowSide, TypeChip, Footnote,
} from '../leave-dashboard/styles';
import { entryColor } from './teamLeavesModel';
import { ScrollArea, PendingChip } from './styles';

// Bugün ekipten izinde olanlar — kişi başına bir satır. Tür yalnız canSeeType satırlarında görünür (sunucu diğerlerinde
// türü hiç göndermez). İzin Paneli'ndeki "Tümünü gör" (/all-leaves) bağlantısı burada YOK: o sayfa LM.Write ister.
export function StatusChip({ entry, canSeeType, typeColors }) {
  const { t } = useTranslation();
  if (entry.status === 'waiting') {
    return (
      <PendingChip>
        {canSeeType && entry.leaveVariationName
          ? `${t('myTeamLeaves.status.waiting')} · ${entry.leaveVariationName}`
          : t('myTeamLeaves.status.waiting')}
      </PendingChip>
    );
  }
  return (
    <TypeChip $bg={entryColor(entry, canSeeType, typeColors)}>
      {canSeeType && entry.leaveVariationName ? entry.leaveVariationName : t('myTeamLeaves.status.approved')}
    </TypeChip>
  );
}

export default function TeamTodayCard({ state, typeColors }) {
  const { t, i18n } = useTranslation();
  const data = state.data;
  const items = data?.items || [];
  const remaining = (data?.totalCount || 0) - items.length;

  const fmtDate = (iso) => {
    const [y, m, d] = iso.split('-').map(Number);
    return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(i18n.language, { day: 'numeric', month: 'short', timeZone: 'UTC' });
  };

  return (
    <DashboardCard
      cardKey="ekibimin-izinleri-bugun"
      title={t('myTeamLeaves.today.title')}
      meta={data ? t('myTeamLeaves.today.meta', { count: data.totalCount }) : null}
      span={4}
      spanMd={6}
      loading={state.loading}
      empty={!state.loading && items.length === 0}
      emptyText={state.error ? t('myTeamLeaves.loadError') : t('myTeamLeaves.today.empty')}
    >
      <ScrollArea>
        {items.map((item) => (
          <ListRow key={item.userId} data-testid={`team-today-${item.userId}`}>
            <RowAvatar src={item.profilePicture} name={item.fullName} initials={initialsOf(item.fullName)} />
            <RowMain>
              <RowName>{item.fullName}</RowName>
              {item.department && <RowSub>{item.department}</RowSub>}
            </RowMain>
            <RowSide>
              <StatusChip entry={item.leave} canSeeType={item.canSeeType} typeColors={typeColors} />
              <RowSub>
                {item.leave.isHourly
                  ? t('myTeamLeaves.today.hours', { count: item.leave.cost })
                  : t('myTeamLeaves.today.returnsOn', { date: fmtDate(item.leave.returnDate) })}
              </RowSub>
            </RowSide>
          </ListRow>
        ))}
        {remaining > 0 && <Footnote>{t('myTeamLeaves.today.more', { count: remaining })}</Footnote>}
      </ScrollArea>
    </DashboardCard>
  );
}
